<script>
export default {
  name: "BaseSplitter",
  props: {
    layout: {
      type: String,
      default: "horizontal"
    },
    gutterSize: {
      type: Number,
      default: 4
    },
    stateKey: {
      type: String,
      default: null
    },
    stateStorage: {
      type: String,
      default: "session"
    },
    step: {
      type: Number,
      default: 5
    }
  },
  mounted() {
    this.$emit("baseSplitter", this);
  },
  computed: {
    rootClasses() {
      return ["p-splitter", "p-component", "p-splitter-" + this.layout];
    },
    gutterClass() {
      return "p-splitter-gutter";
    },
    gutterHandlerClass() {
      return "p-splitter-gutter-handle";
    },
    inlineStyles() {
      return {
        root: {
          display: "flex",
          "flex-wrap": "nowrap",
          "flex-direction": this.layout === "vertical" ? "column" : ""
        }
      };
    }
  },
  render() {
    return null;
  }
};
</script>

<style>
.p-splitter {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  min-height: calc(100vh - 110px);
}

.p-splitter-vertical {
  flex-direction: column;
}

.p-splitter-gutter {
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;
  z-index: 999;
}

.p-splitter-horizontal.p-splitter-resizing {
  cursor: col-resize;
  user-select: none;
}

.p-splitter-horizontal > .p-splitter-gutter > .p-splitter-gutter-handle {
  height: 24px;
  width: 100%;
}

.p-splitter-horizontal > .p-splitter-gutter {
  cursor: col-resize;
}

.p-splitter-vertical.p-splitter-resizing {
  cursor: row-resize;
  user-select: none;
}

.p-splitter-vertical > .p-splitter-gutter {
  cursor: row-resize;
}

.p-splitter-vertical > .p-splitter-gutter > .p-splitter-gutter-handle {
  width: 24px;
  height: 100%;
}
.p-splitter .p-splitter-gutter .p-splitter-gutter-handle {
  background: var(--textinactive-alpha);
  border-radius: 2px;
  border: 1px solid var(--textinactive);
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
}
@media (min-height: 800px) {
  .p-splitter {
    min-height: 90vh;
  }
}
</style>
